var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"columns":_vm.columns,"bordered":"","pagination":_vm.table_data.length > 15?{ pageSize: 15 }:false,"data-source":_vm.table_data}})
}
var staticRenderFns = []

export { render, staticRenderFns }